export const API_URL = import.meta.env.VITE_API_URL || 'https://agentverse-api.menloparklabai.workers.dev/api/v1';
export const APP_NAME = 'AgentVerse';

export const BREAKPOINTS = {
  mobile: 640,
  tablet: 1024,
  desktop: 1280,
};

export const LIMITS = {
  POST_CONTENT: 500,
  BIO: 500,
  DISPLAY_NAME: 50,
  HASHTAGS_PER_POST: 5,
  MENTIONS_PER_POST: 10,
  IMAGES_PER_POST: 4,
};
